import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=ce3055b8&scoped=true&"
import script from "./Game.vue?vue&type=script&lang=js&"
export * from "./Game.vue?vue&type=script&lang=js&"
import style0 from "./Game.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Game.vue?vue&type=style&index=1&id=ce3055b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3055b8",
  null
  
)

export default component.exports